<script>
import "./style.scss"

let createEl, self;

const defaultList = [
  { label: 'key1', value: 'value' },
  { label: 'key2', value: 'value' },
  { label: 'key3', value: 'value' },
  { label: 'key4', value: 'value' },
  { label: 'key5', value: 'value' },
  { label: 'key6', value: 'value' },
  { label: 'key7', value: 'value' },
  { label: 'key8', value: 'value' },
  { label: 'key9', value: 'value' },
  { label: 'key0', value: 'value' },
];

const valueStyle = {
  backgroundColor: '#fff'
}

const props = {
  list: { 
    type: Array, 
    default: function () { return defaultList }
  }
}

const formatList = function(list) {
  let row = []; 
  let result = [];

  if (Object.prototype.toString.call === '[object Array]') return [];

  list.forEach((item, index) => {
    if (index % 2 == 0) row = [];
    else result.push(row);
    item.attrs = {}
    row.push(item);
  });

  console.log(result);
  return result;
}

/**
 * 根据props.list生成临时表格
 */
function render(create) {
  createEl = create;
  self = this;

  return createEl('table', {
    class: "dhx__table-temp"
  }, [
    formatList(self.list).map(row =>
      createEl('tr', {
          class: "dhx__table-temp-row"
        }, row.map(item => [
          createEl('td', {}, item.label),
          createEl('td', { style: valueStyle }, item.value)
        ]).flat()
      )
    )
  ])
}

export default { props, render }
</script>


// WEBPACK FOOTER //
// src/views/collection/manage/tableTemp/index.vue